module.exports = __webpack_public_path__ + "img/nio.ecdb97f3.svg";